const replaceParamUrl = (url = '', params = {}) => {
    let urlNew = url;
    Object.keys(params).forEach((key) => {
        urlNew = urlNew.replace(`{${key}}`, params[key]);
    });
    return urlNew;
}

const saveDataToken = (responseData) => {
    const data = {
        created: Date.now(),
        expires: Number(responseData.expires_in) - 10,
        token: responseData.access_token
    }
    const value = JSON.stringify(data);
    sessionStorage.setItem("infoToken", value);
}

const getDataToken = () => {
    const data = sessionStorage.getItem("infoToken");
    let token = null;
    if (data) {

        const cache = JSON.parse(data);
        const diffSeconds = (new Date() - new Date(cache.created)) / 1000;

        if (diffSeconds > Number(cache.expires)) {
            sessionStorage.removeItem("infoToken");
        } else {
            token = cache.token;
        }

    }
    return token;
}

export const serviceUtil = {
    replaceParamUrl,
    saveDataToken,
    getDataToken
}